import { resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, createElementVNode as _createElementVNode, withCtx as _withCtx, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createBlock as _createBlock, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = { class: "space-y-6 p-4 sm:p-6 lg:p-8" }
const _hoisted_2 = { class: "flex items-center space-x-2" }
const _hoisted_3 = { class: "flex items-center text-xl font-semibold text-gray-800" }
const _hoisted_4 = { class: "mb-4 text-xs font-semibold uppercase tracking-widest text-indigo-200 sm:text-sm" }
const _hoisted_5 = {
  key: 0,
  class: "flex w-full flex-col items-center"
}
const _hoisted_6 = { class: "mb-6 flex justify-center space-x-2 sm:space-x-3" }
const _hoisted_7 = { class: "flex flex-col items-center space-y-3" }
const _hoisted_8 = { class: "text-xs font-light text-indigo-300" }
const _hoisted_9 = { class: "flex flex-col items-center py-6 text-center text-indigo-300" }
const _hoisted_10 = { class: "text-sm" }
const _hoisted_11 = { class: "space-y-4" }
const _hoisted_12 = { class: "flex items-center text-lg font-bold text-gray-800" }
const _hoisted_13 = { class: "overflow-x-auto rounded-lg border border-gray-200 bg-white shadow-sm" }
const _hoisted_14 = { class: "min-w-full divide-y divide-gray-200" }
const _hoisted_15 = { class: "bg-gray-50" }
const _hoisted_16 = { class: "px-6 py-3 text-left text-xs font-medium uppercase tracking-wider text-gray-500" }
const _hoisted_17 = { class: "px-6 py-3 text-left text-xs font-medium uppercase tracking-wider text-gray-500" }
const _hoisted_18 = { class: "px-6 py-3 text-left text-xs font-medium uppercase tracking-wider text-gray-500" }
const _hoisted_19 = { class: "divide-y divide-gray-200 bg-white" }
const _hoisted_20 = { class: "whitespace-nowrap px-6 py-4 font-mono text-sm font-bold text-indigo-600" }
const _hoisted_21 = { class: "whitespace-nowrap px-6 py-4 text-sm text-gray-500" }
const _hoisted_22 = { class: "max-w-lg break-words px-6 py-4 text-sm text-gray-600" }
const _hoisted_23 = { key: 0 }
const _hoisted_24 = {
  colspan: "3",
  class: "px-6 py-8 text-center text-sm italic text-gray-500"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_UiBackButton = _resolveComponent("UiBackButton")!
  const _component_UiPageHeader = _resolveComponent("UiPageHeader")!
  const _component_UiPanel = _resolveComponent("UiPanel")!
  const _component_UiPagination = _resolveComponent("UiPagination")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_UiPageHeader, null, {
      info: _withCtx(() => [
        _createElementVNode("div", _hoisted_2, [
          _createVNode(_component_UiBackButton, { "fallback-to": { name: 'ListWhatsappCodeNumbers' } }),
          _createElementVNode("h1", _hoisted_3, [
            _createVNode($setup["SVGWhatsApp"], { class: "mr-1.5 h-6 w-6 text-[#25D366]" }),
            _createTextVNode(" " + _toDisplayString($setup.number
                                ? _ctx.$t('whatsappCode.monitoringNumber', {
                                      number: $setup.applyPhoneMask($setup.number.number),
                                  })
                                : _ctx.$t('whatsappCode.title')), 1 /* TEXT */)
          ])
        ])
      ]),
      _: 1 /* STABLE */
    }),
    _createCommentVNode(" Premium Display for Latest Active Code "),
    _createVNode(_component_UiPanel, { class: "mx-auto flex max-w-xl flex-col items-center overflow-hidden rounded-2xl border border-indigo-100 bg-gradient-to-br from-indigo-900 to-indigo-950 p-6 text-white shadow-lg sm:p-8" }, {
      default: _withCtx(() => [
        _createElementVNode("span", _hoisted_4, _toDisplayString(_ctx.$t('whatsappCode.lastReceivedCode')), 1 /* TEXT */),
        ($setup.latestCode)
          ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
              _createCommentVNode(" Digit Boxes "),
              _createElementVNode("div", _hoisted_6, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.digitChars, (char, idx) => {
                  return (_openBlock(), _createElementBlock("div", {
                    key: `digit-${idx}`,
                    class: "flex h-14 w-11 transform items-center justify-center rounded-xl border border-white/20 bg-white/10 font-mono text-2xl font-extrabold text-white shadow-inner backdrop-blur-md transition-transform duration-150 hover:scale-105 sm:h-20 sm:w-14 sm:text-4xl"
                  }, _toDisplayString(char), 1 /* TEXT */))
                }), 128 /* KEYED_FRAGMENT */))
              ]),
              _createElementVNode("div", _hoisted_7, [
                _createElementVNode("button", {
                  class: _normalizeClass(["flex items-center space-x-2 rounded-lg px-6 py-2 text-sm font-medium shadow-md transition-all duration-150 focus:outline-none", [
                            $setup.copied
                                ? 'bg-green-600 text-white hover:bg-green-700'
                                : 'bg-indigo-600 text-white hover:bg-indigo-700',
                        ]]),
                  onClick: $setup.copyToClipboard
                }, [
                  (!$setup.copied)
                    ? (_openBlock(), _createBlock($setup["ClipboardIcon"], {
                        key: 0,
                        class: "mr-1 h-4 w-4"
                      }))
                    : (_openBlock(), _createBlock($setup["CheckIcon"], {
                        key: 1,
                        class: "mr-1 h-4 w-4 text-green-300"
                      })),
                  _createElementVNode("span", null, _toDisplayString($setup.copied ? _ctx.$t('whatsappCode.copied') : _ctx.$t('whatsappCode.copyCode')), 1 /* TEXT */)
                ], 2 /* CLASS */),
                _createElementVNode("span", _hoisted_8, _toDisplayString(_ctx.$t('whatsappCode.table.receivedAt')) + ": " + _toDisplayString($setup.formatTime($setup.latestCode.receivedAt)), 1 /* TEXT */)
              ])
            ]))
          : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
              _createCommentVNode(" Empty State for Monitor "),
              _createElementVNode("div", _hoisted_9, [
                _createVNode($setup["SVGWhatsApp"], { class: "mb-3 h-10 w-10 animate-pulse text-[#25D366]" }),
                _createElementVNode("p", _hoisted_10, _toDisplayString(_ctx.$t('whatsappCode.noCodesReceived')), 1 /* TEXT */)
              ])
            ], 2112 /* STABLE_FRAGMENT, DEV_ROOT_FRAGMENT */))
      ]),
      _: 1 /* STABLE */
    }),
    _createCommentVNode(" Chronological Code History List "),
    _createElementVNode("div", _hoisted_11, [
      _createElementVNode("h2", _hoisted_12, [
        _createVNode($setup["DocumentTextIcon"], { class: "mr-1 h-5 w-5 text-gray-500" }),
        _createTextVNode(" " + _toDisplayString(_ctx.$t('whatsappCode.history')), 1 /* TEXT */)
      ]),
      _createElementVNode("div", _hoisted_13, [
        _createElementVNode("table", _hoisted_14, [
          _createElementVNode("thead", _hoisted_15, [
            _createElementVNode("tr", null, [
              _createElementVNode("th", _hoisted_16, _toDisplayString(_ctx.$t('whatsappCode.table.code')), 1 /* TEXT */),
              _createElementVNode("th", _hoisted_17, _toDisplayString(_ctx.$t('whatsappCode.table.receivedAt')), 1 /* TEXT */),
              _createElementVNode("th", _hoisted_18, _toDisplayString(_ctx.$t('whatsappCode.table.transcript')), 1 /* TEXT */)
            ])
          ]),
          _createElementVNode("tbody", _hoisted_19, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.codes, (code) => {
              return (_openBlock(), _createElementBlock("tr", {
                key: code.id,
                class: _normalizeClass([[
                                $setup.newlyReceivedId === code.id
                                    ? 'animate-new-row'
                                    : 'hover:bg-gray-50/50',
                            ], "transition-colors duration-150"])
              }, [
                _createElementVNode("td", _hoisted_20, _toDisplayString(code.code), 1 /* TEXT */),
                _createElementVNode("td", _hoisted_21, _toDisplayString($setup.formatTime(code.receivedAt)), 1 /* TEXT */),
                _createElementVNode("td", _hoisted_22, _toDisplayString(code.transcript || '-'), 1 /* TEXT */)
              ], 2 /* CLASS */))
            }), 128 /* KEYED_FRAGMENT */)),
            ($setup.codes.length === 0)
              ? (_openBlock(), _createElementBlock("tr", _hoisted_23, [
                  _createElementVNode("td", _hoisted_24, _toDisplayString(_ctx.$t('core.messages.noRecordsFound')), 1 /* TEXT */)
                ]))
              : _createCommentVNode("v-if", true)
          ])
        ])
      ]),
      ($setup.codes.length)
        ? (_openBlock(), _createBlock(_component_UiPagination, {
            key: 0,
            modelValue: $setup.currentPage,
            "onUpdate:modelValue": [
              _cache[0] || (_cache[0] = ($event: any) => (($setup.currentPage) = $event)),
              $setup.handlePageChange
            ],
            count: $setup.count,
            perPage: $setup.perPage
          }, null, 8 /* PROPS */, ["modelValue", "count"]))
        : _createCommentVNode("v-if", true)
    ])
  ]))
}